/**
 * Created by rathompson on 6/13/22
 * File: ExpiryRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useMemo } from 'react'
import { ARRAY } from '../../../../common/utils/Utils'
import { getDateFormat } from '../../../../subscription/util/common'
import { Body } from '@panwds/react-ui'

const ExpiryRenderer = ({ row, value }) => {

  const [expiration, original] = useMemo(() => {
    let status = value
    let original = row?.original
    if (row?.depth === 0 && ARRAY.hasArray(row?.subRows) && !row?.isExpanded) {
      original = row?.subRows[0]?.original
      status = original?.license_expiration
    }
    return [status, original]
  }, [row?.depth, row?.isExpanded, row?.original, row?.subRows, value])

  return <Body>{getDateFormat({ original }, expiration)}</Body>
}

export default ExpiryRenderer
